import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React, { useRef, useContext } from 'react';
import { ScreenSizeContext } from '../Measured/ScreenSizeContext';
import { useMeasuredCookie } from '../Measured/useMeasuredCookie';
import { default as Grid } from './Grid';
const MeasuredGrid = (_param)=>{
    var { cookieType  } = _param, gridProps = _object_without_properties(_param, [
        "cookieType"
    ]);
    const { width: screenWidth  } = useContext(ScreenSizeContext);
    const containerRef = useRef(null);
    const sentinelRef = useRef(null);
    const measuredContainer = useMeasuredCookie(cookieType, containerRef, {
        cookieDim: 'width',
        listenOnWindow: true,
        sentinelRef
    });
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        ref: sentinelRef,
        style: {
            maxWidth: '100%'
        }
    }), /*#__PURE__*/ React.createElement("div", {
        ref: containerRef
    }, /*#__PURE__*/ React.createElement(Grid, _extends({}, gridProps, {
        screenWidth: screenWidth,
        containerWidth: measuredContainer === null || measuredContainer === void 0 ? void 0 : measuredContainer.width
    }))));
};
MeasuredGrid.displayName = 'MeasuredGrid';
export default MeasuredGrid;
